import React, { useCallback } from 'react';
import useQuery from './hooks/use-query';
import MainViewWrapper from './views/main-view/main-view-wrapper';
import PreviewView from './views/preview-view/preview-view';
import ShareView from './views/share-view/share-view';
import { SHARE_VIEW, QUOTES_VIEW, DOCUMENTS_VIEW } from './constants/view-types';
import withError from './enhancers/with-error';

import 'monday-ui-react-core/dist/main.css';
import 'monday-ui-style/dist/index.css';
import './App.scss';

function App() {
  const query = useQuery();
  const renderView = useCallback(() => {
    const view = query.get('view');

    switch (view) {
      case SHARE_VIEW:
        return <ShareView />;
      case QUOTES_VIEW:
        return <PreviewView />;
      case DOCUMENTS_VIEW:
        return <PreviewView />;
      default:
        return <MainViewWrapper />;
    }
  }, [query]);

  return <div className="App">{renderView()}</div>;
}

export default withError(App);
